import css from './Media.module.css';

const News = ({ env }: { env: string }) => {
  // TODO: Переделать на дельту
  const domain = env === 'su' ? 'su' : 'staging-1';

  return (
    <div className={css.news}>
      <iframe
        className={css.newsFrame}
        height={400}
        src={`//news.ati.${domain}/external/last-news/?count=5&with_time=1`}
        title="News"
        width={370}
      ></iframe>
    </div>
  );
};

export { News };
